<template>
    <b-row>
        <b-colxx md="6">
            <b-form-group label="Month" class="has-float-label">
                <template v-slot:label>
                    <span>Month <sup><code>*</code></sup></span>
                </template>
                <v-select v-model="selectedMonth" @input="$emit('month-changed', $event)" :options="selectMonth"/>
            </b-form-group>
        </b-colxx>

        <b-colxx md="6">
            <b-form-group label="Year" class="has-float-label">
                <template v-slot:label>
                    <span>Year <sup><code>*</code></sup></span>
                </template>
                <v-select v-model="selectedYear" @input="$emit('year-changed', $event)" :options="selectYears"/>
            </b-form-group>
        </b-colxx>
    </b-row>
</template>

<script>
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';

    export default {
        name: "MonthPicker",
        components: {
            'v-select': vSelect,
        },
        props: [
            'minYear', 'maxYear'
        ],
        data() {
            let today = new Date();
            let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

            return {
                selectedYear: {
                    label: today.getFullYear(),
                    value: today.getFullYear()
                },
                selectedMonth: {
                    label: null,
                    value: null
                },
                selectMonth: [
                    {label: 'January', value: '01'},
                    {label: 'February', value: '02'},
                    {label: 'March', value: '03'},
                    {label: 'April', value: '04'},
                    {label: 'May', value: '05'},
                    {label: 'June', value: '06'},
                    {label: 'July', value: '07'},
                    {label: 'August', value: '08'},
                    {label: 'September', value: '09'},
                    {label: 'October', value: '10'},
                    {label: 'November', value: '11'},
                    {label: 'December', value: '12'},
                ],
                selectYears: [],
            }
        },
        beforeMount() {
            this.generateYears(this.minYear, this.maxYear);
        },
        methods: {
            generateYears(min, max) {
                for (let i = max; i >= min; i--) {
                    this.selectYears.push({
                        label: i, value: i,
                    });
                }
            },
        },
    }
</script>

<style scoped>

</style>
